"use client";
import { useTranslations } from "next-intl";
import Icon from "./Icon";

const MobileBackButton = ({ onClick }) => {
  const t = useTranslations();
  return (
    <button
      onClick={onClick}
      className="mt-3 pt-1 d-inline-flex gap-2 align-items-center color-white hide-on-not-mobile"
      aria-label="Go back one level"
    >
      <Icon icon="chevron-left" />
      {t("back")}
    </button>
  );
};

export default MobileBackButton;
